import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthProvider } from '@domain/authentication';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutingKeys, PlatformName, PlatformProvider } from '@shared';
import {
	notAllowedCharactersValidation,
	startWithCharactersValidation
} from '../../domain/dynamic-form/validations/validator-functions/custom-form-validations';
import { firstValueFrom, map } from 'rxjs';
import { WorkspaceModel, WorkspaceRepository } from '@database/central';
import { StorageService } from '@shared';

@Component({
	selector: 'app-no-api-mode',
	templateUrl: 'no-api-mode.component.html',
	styleUrls: ['no-api-mode.component.scss']
})
export class NoApiModeComponent implements OnInit {
	public formValidationMessages = [];
	public usernameControl: UntypedFormControl;
	public noApiModeForm: UntypedFormGroup;
	public platform = this.platformProvider.getPlatform();
	public platformName = PlatformName;
	public noAPIStatus: any;

	public constructor(
		private navController: NavController,
		private translate: TranslateService,
		private platformProvider: PlatformProvider,
		private authProvider: AuthProvider,
		private storageService: StorageService,
		private workspaceRepository: WorkspaceRepository
	) {}

	public ngOnInit() {
		this.usernameControl = new UntypedFormControl('', [
			Validators.required,
			Validators.maxLength(30),
			startWithCharactersValidation,
			notAllowedCharactersValidation
		]);

		this.noApiModeForm = new UntypedFormGroup({
			usernameControl: this.usernameControl
		});

		this.formValidationMessages = [
			{
				type: 'required',
				message: this.translate.instant('registration.form.validations.username.required')
			},
			{ type: 'maxlength', message: this.translate.instant('registration.form.validations.username.maxlength') },
			{
				type: 'startWithCharacters',
				message: this.translate.instant('registration.form.validations.username.startWithCharacters')
			},
			{
				type: 'notAllowedCharacters',
				message: this.translate.instant('registration.form.validations.username.notAllowedCharacters')
			}
		];
	}

	public goBack(): void {
		this.navController.pop();
	}

	public async onSubmit(usernameControl: string): Promise<void> {
		if (!this.isFormValid()) {
			return;
		}

		await this.authProvider.setFusionUserId(usernameControl);
		await this.logOnNoApi();
		
		await firstValueFrom(
			this.workspaceRepository.getAllByFusionUserId$(usernameControl).pipe(
				map((workFiles: WorkspaceModel[]) => {
					const workFilesFiltered = workFiles
						.filter((workFile: WorkspaceModel) => !workFile.pendingDelete)
						.sort((a, b) => a.importedUnix - b.importedUnix);

					if (workFilesFiltered.length > 0) {
						// redirect to last imported workfile
											// redirect to import page
						return this.navController.navigateRoot(
							`/${AppRoutingKeys.urlPathWorkfile}/${workFilesFiltered.pop().workFileId}`
						);
					}
					
					return this.navController.navigateRoot(`/${AppRoutingKeys.urlPathImport}`);
				})
			)
		);
	}

	public async logOnNoApi(){
		this.noAPIStatus = await this.storageService.get("NO_API")
		if(this.noAPIStatus == null) {await this.storageService.set("NO_API", 0)}
		this.noAPIStatus = await this.storageService.get("NO_API")
		if(this.noAPIStatus == 0) {await this.storageService.set("NO_API", 1)}
		this.noAPIStatus = await this.storageService.get("NO_API")

		return this.noAPIStatus 
	}

	public isFormValid(): boolean {
		return this.noApiModeForm.valid;
	}
}
